import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { AlertTitle, Chip } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import Alert from '@mui/material/Alert';
import { AppError } from '../../../types/appError';

type Props = {
  readonly errors: AppError[];
  readonly onCloseError?: (index: number) => void;
};

export const AppErrorList = (props: Props) => {
  const { errors, onCloseError } = props;

  const renderError = (appError: AppError, index: number) => {
    const closeHandler = onCloseError
      ? () => onCloseError(index)
      : undefined;

    return (
      <Alert key={index} severity='error' onClose={closeHandler} icon={false}>
        <Chip icon={<ErrorIcon/>} color='error' label='Error' sx={{mb: 2}}/>

        <AlertTitle>{appError.error}</AlertTitle>
        <p>{appError.message}</p>

        {appError.details && (
          <ul>
            {appError.details?.map((detail, idx) => (
              <li key={idx}>{detail}</li>
            ))}
          </ul>
        )}
      </Alert>
    );
  };

  return (
    <Stack spacing={2} divider={<Divider flexItem />}>
      { errors.map(renderError) }
    </Stack>
  );
};
